import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {AdminEntityService} from "./AdminEntityService";
import {injectable} from "inversify";
import {ListSystemEventsResponse} from "../../../generated/protocol";
import {SystemEventView} from "../../../generated/protocol";


export interface SystemEventService extends AdminEntityService<SystemEventView> {
    markAcknowledged(id: number): Promise<{}>
}

@injectable()
export class SystemEventServiceImpl extends AbstractAdminEntityService<SystemEventView, ListSystemEventsResponse> {

    constructor() {
        super("/system-events");
    }

    save(entity: SystemEventView): Promise<SystemEventView> {
        throw "Unsupported Operation";
    }

    remove(id: string): Promise<{}> {
        throw "Unsupported Operation";
    }

    markAcknowledged(id: number): Promise<{}> {
        return this.http.doGet(this.entityPath + "/ack/" + id);
    }

}



// WEBPACK FOOTER //
// ./src/app/service/admin/SystemEventService.ts